module.exports = __webpack_public_path__ + "static/media/logo.f62d665f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.jpg
// module id = 1304
// module chunks = 0